import { Provider } from '@angular/core';
import { APP_BRANDING, AppBranding } from '@features/apps/branding/app-branding';

/**
 * Branding do app GitHub - a face visual do GitHub nas superfícies do produto (chip do mundo
 * no mapa de vínculos, catálogo). Todo o específico do GitHub (logo) vive AQUI, em
 * `features/apps/github`, e não nos componentes agnósticos.
 */
export const GITHUB_BRANDING: AppBranding = {
  slug: 'github',
  name: 'GitHub',
  logo: 'assets/logo/github.svg',
};

/** Registra o branding do GitHub no token multi `APP_BRANDING` (usar no app.config). */
export function provideGithubBranding(): Provider {
  return { provide: APP_BRANDING, useValue: GITHUB_BRANDING, multi: true };
}
